import { LAUNCH_DATE } from "../puzzle/generator.ts";
import { MAX_ATTEMPTS } from "../shared/game-rules.ts";

export const APP_CONFIG = {
  name: "Codelet",
  shortName: "Codelet",
  tagline: "Guess the Code?",
  siteUrl: "https://codelet.uk",
  launchDate: LAUNCH_DATE,
  timezone: "UTC",
  maxAttempts: MAX_ATTEMPTS,
  codeLength: 3,
} as const;